import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import ChatContainer from '../components/Chat/ChatContainer'
import SessionSidebar from '../components/Chat/SessionSidebar'

function ChatPage() {
  const { sessionId } = useParams()
  const navigate = useNavigate()

  // Drawer state for the session sidebar. On desktop the sidebar is always
  // visible (static flex child); on mobile it slides in over the chat. State
  // lives here because the toggle button is in ChatContainer's header. The
  // sidebar closes itself via onClose when a session is selected or created.
  const [sidebarOpen, setSidebarOpen] = useState(false)

  // Redirect bare /chat to a new session URL (one-time)
  useEffect(() => {
    if (!sessionId) {
      const newSessionId = crypto.randomUUID()
      navigate(`/chat/${newSessionId}`, { replace: true })
    }
  }, [sessionId, navigate])

  // While redirecting, show loading state
  if (!sessionId) {
    return (
      <div className="flex items-center justify-center h-full bg-dark-50">
        <div className="text-space-400 text-lg">Initializing chat session...</div>
      </div>
    )
  }

  // Use sessionId directly from URL params — no intermediate state that can
  // lag one render behind. The key prop forces React to destroy and recreate
  // ChatContainer (and its WebSocket) when navigating between sessions.
  return (
    <div className="flex h-full overflow-hidden">
      <SessionSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex-1 min-w-0">
        <ChatContainer
          key={sessionId}
          sessionId={sessionId}
          onMenuClick={() => setSidebarOpen(true)}
        />
      </div>
    </div>
  )
}

export default ChatPage
